import { updateFilterAction } from '@/main/store/actionsFunctions';
import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { apiProvider } from '../api';
import { NAME, CRUMB_LABEL_KEY, OBRAT_FILTER } from '../constants';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter: {
		DatumOd: null as string | null,
		DatumDo: null as string | null,
		ZakaznikId: null as number | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {
		[OBRAT_FILTER]: ({ state, commit, dispatch }: any) => (
			updateFilterAction(state, commit, dispatch, apiProvider.obratFilter())
		),
	},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
